﻿export default class ShipmentTrackingDomGenerator {
	createDocumentLinks(documents) {
		const links = [];
		let shipmentNumber = 1;
		documents.forEach((documentLink) => {
			const li = document.createElement("li");
			const link = document.createElement("a");
			link.target = "_blank";
			link.title = documentLink.Link.Text;
			link.href = documentLink.Link.LinkUrl;
			link.classList.add("a-link");
			link.classList.add("pure-u-md-12-24");
			const text = "Shipment batch #" + shipmentNumber + ": " + documentLink.Link.Text;
			const linkText = document.createTextNode(text);

			link.appendChild(linkText);
			li.appendChild(link);

			const metaData = document.createElement("span");
			metaData.innerText = "Shipment company: " + documentLink.Metadata;
			li.appendChild(metaData);

			links.push(li);

			shipmentNumber++;
		});

		return links;
	}
}
